"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sectionHeaderModule = _interopRequireDefault(require("./section-header.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SectionHeader = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
      classNameForContent = _ref.classNameForContent,
      icon = _ref.icon,
      title = _ref.title,
      editButtonComponent = _ref.editButtonComponent,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_sectionHeaderModule["default"].sectionHeader, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _sectionHeaderModule["default"].titleContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _sectionHeaderModule["default"].title
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _sectionHeaderModule["default"].iconContainer
  }, icon), /*#__PURE__*/_react["default"].createElement("span", {
    className: _sectionHeaderModule["default"].titleText
  }, title), /*#__PURE__*/_react["default"].createElement("span", {
    className: _sectionHeaderModule["default"].editComponent
  }, editButtonComponent))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_sectionHeaderModule["default"].content, classNameForContent)
  }, children));
});

SectionHeader.propTypes = {
  className: _propTypes["default"].string,
  classNameForContent: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  title: _propTypes["default"].node,
  editButtonComponent: _propTypes["default"].node,
  children: _propTypes["default"].node
};
SectionHeader.defaultProps = {
  className: '',
  classNameForContent: '',
  icon: null,
  title: '',
  editButtonComponent: null,
  children: null
};
var _default = SectionHeader;
exports["default"] = _default;